import React from 'react';
import { Typography } from 'antd';
import styled from 'styled-components';

import { HistoryEntryEnum } from '../../common/types';
import { UserAvatar } from '../../components/InitialsBadgeTableCell';
import { HistoryType } from '../recruitments/Recruitments.types';

import { EntryContainer } from './EntryContainer';

const EntryHeaderWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
`;

const EntryHeaderValue = styled.div`
  color: white;
  padding: 2px 5px;
  text-align: center;
  font-weight: bold;
`;

const GenericChangeHeader = ({
  label,
  value,
  backgroundColor,
}: {
  label: React.ReactNode;
  value: React.ReactNode;
  backgroundColor?: string;
}) => (
  <EntryHeaderWrapper>
    <div>{label}</div>
    {typeof value === 'string' ? (
      <EntryHeaderValue style={{ background: backgroundColor || 'none' }}>{value}</EntryHeaderValue>
    ) : (
      value
    )}
  </EntryHeaderWrapper>
);

const StatusChangeHeader = ({ name }: { name: string }) => (
  <GenericChangeHeader label="Status changed to:" value={name} backgroundColor="#4D88FF" />
);

const ResponsibleChangeHeader = ({ name }: { name: string }) => (
  <GenericChangeHeader
    label="Responsible changed to:"
    value={
      <div style={{ display: 'flex', gap: '5px' }}>
        <UserAvatar userName={name} />
        <Typography.Text>{name}</Typography.Text>
      </div>
    }
  />
);
const PerfectMatchChangeHeader = ({ name }: { name: string }) => (
  <GenericChangeHeader
    label="Perfect match changed to:"
    value={name}
    backgroundColor={name === 'Perfect match' ? '#00802b' : '#909090'}
  />
);

const EntryHeader = ({ type, name }: { type: string; name: string }) => {
  switch (type) {
    case HistoryEntryEnum.STATUS:
      return <StatusChangeHeader name={name} />;

    case HistoryEntryEnum.RESPONSIBLE:
      return <ResponsibleChangeHeader name={name} />;

    case HistoryEntryEnum.PERFECT_MATCH:
      return <PerfectMatchChangeHeader name={name} />;

    default:
      return <GenericChangeHeader label={`${type}:`} value={name} />;
  }
};

type HistoryEntryProps = {
  history: HistoryType;
};

export const HistoryEntry: React.FC<HistoryEntryProps> = ({ history }) => (
  <EntryContainer
    header={<EntryHeader type={history.type} name={history.statusName} />}
    date={history.date}
    user={history.user}
  />
);
